import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "group",
    "criteria",
    "groupNumberInput",
    "groupNumberDisplay",
    "criterionDeleteBtn"
  ]

  connect() {
    this.disableLastDeleteButton();
    this.syncGroupMatchAny();
  }

  updateGroupNumbers() {
    this.disableLastDeleteButton();
    this.triggerOutOfGroupEvents();
    this.removeEmptyGroups();
    this.renumberGroups();
    this.syncGroupMatchAny();
  }

  disableLastDeleteButton() {
    if (this.criterionDeleteBtnTargets.length === 1) {
      const btn = this.criterionDeleteBtnTargets[0].querySelector('button')
      const message = this.criterionDeleteBtnTargets[0].querySelector('.d-none')
      btn.disabled = true;
      message.classList.remove('d-none')
    } else if (this.criterionDeleteBtnTargets.length > 1) {
      this.criterionDeleteBtnTargets.forEach((btn) => {
        let eachBtn = this.criterionDeleteBtnTargets[0].querySelector('button')
        let eachMessage = this.criterionDeleteBtnTargets[0].querySelector('.small')
        eachBtn.disabled = false;
        eachMessage.classList.add('d-none')
      });
    }
  }

  triggerOutOfGroupEvents() {
    this.criteriaTargets.forEach((criteria) => {
      if (!this.groupTargets.some((group) => group.contains(criteria))) {
        this.dispatch("out-of-group", { target: criteria });
      }
    })
  }

  removeEmptyGroups() {
    this.groupTargets.forEach((group) => {
      const anyCriteria = this.criteriaTargets.find((criteria) => group.contains(criteria)) ? true : false;
      if (!anyCriteria) {
        group.remove();
      }
    });
  }

  renumberGroups() {
    this.groupTargets.forEach((group, index) => {
      this.groupNumberDisplayTargets
        .filter((display) => group.contains(display))
        .forEach((display) => { display.textContent = index });
      this.groupNumberInputTargets
        .filter((input) => group.contains(input))
        .forEach((input) => { input.value = index });
    });
  }

  syncGroupMatchAny() {
    this.groupTargets.forEach((group) => {
      const checkbox = group.querySelector('.match-label input[type="checkbox"]');
      if (!checkbox) return;
      const value = checkbox.checked.toString();
      group.querySelectorAll('[data-group="match-any-input"]').forEach((input) => {
        input.value = value;
      });
    });
  }
}
